<template>
  <ContentSection :spacing="isSidebar ? 'none': 'md'">
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />
    <figure
      :class="{
        'w-full': data.image_width.value === 'full',
        'w-2/3': data.image_width.value === '2of3',
        'w-1/2': data.image_width.value === '1of2',
        'w-1/3': data.image_width.value === '1of3',
        'w-1/4': data.image_width.value === '1of4',
        'w-max max-w-full': data.image_width.value === 'actual',
        'min-w-40': data.image_width.value !== 'actual',
      }"
    >
      <AppImage
        v-if="data.image"
        :src="data.image"
        :style="imageStyle"
        :class="{
          'rounded-bl-xl': isSidebar,
        }"
      />
      <figcaption>
        <Copyright :copyright="data.copyright" />
      </figcaption>
    </figure>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsImageFragment } from '#gql'
import type { CSSProperties } from 'vue'

const props = defineProps<{ data: Enforce<MainComponentsImageFragment> }>()

const isSidebar = inject<boolean>('isSidebar', false)

const imageStyle = computed(() => {
  const style: CSSProperties = {}

  if (props.data.image.focus_css) {
    style.objectPosition = props.data.image.focus_css
  }

  if (props.data.image_width.value === 'actual') {
    style.width = props.data.image.width + 'px'
  }

  return style
})
</script>
